// Entering Avo from the main app must be a full page load — otherwise the
// main app's Turbo/Stimulus keeps driving Avo pages alongside Avo's own
// bundle. The mirror-image guard (leaving Avo) lives in
// app/views/avo/partials/_head.html.erb, since Avo pages don't load this
// bundle. See the fault links there for the errors this prevents.
document.addEventListener("turbo:before-visit", event => {
  const url = new URL(event.detail.url, window.location.origin)
  if (url.origin !== window.location.origin) return
  if (url.pathname !== "/avo" && !url.pathname.startsWith("/avo/")) return

  event.preventDefault()
  window.location.assign(event.detail.url)
})
